import React from 'react';
import { FadeIn } from './FadeIn';
export function Services() {
  return <section id="servicios" className="py-[120px] px-[5%] bg-gris-oscuro relative" data-id="element-201">
      <FadeIn className="text-center mb-[70px]" data-id="element-202">
        <span className="inline-block bg-azul-neon/10 border border-azul-neon/30 text-acento text-[12px] font-semibold tracking-[2px] uppercase px-[16px] py-[6px] rounded-full mb-[18px]" data-id="element-203">
          Lo que hacemos
        </span>
        <h2 className="font-rajdhani text-[clamp(32px,4vw,52px)] font-bold leading-[1.1] mb-[16px]" data-id="element-204">
          Nuestros <span className="text-acento" data-id="element-205">Servicios</span>
        </h2>
        <p className="text-texto-gris text-[16px] max-w-[520px] mx-auto leading-[1.7]" data-id="element-206">
          Soluciones completas para tu vehículo con diagnóstico de última
          generación.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(320px,1fr))] gap-[24px] max-w-[1200px] mx-auto" data-id="element-207">
        {/* DIAGNÓSTICO & MOTOR */}
        <FadeIn data-id="element-208">
          <div className="bg-gris-medio border border-white/5 rounded-[16px] p-[36px_32px] transition-all duration-300 relative overflow-hidden group hover:-translate-y-[6px] hover:border-azul-neon/40 hover:shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)] hover:bg-[#1e2130]" data-id="element-209">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-azul to-acento opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-210"></div>
            <div className="w-[56px] h-[56px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[14px] flex items-center justify-center mb-[22px]" data-id="element-211">
              <i className="fas fa-microchip text-[24px] text-acento" data-id="element-212"></i>
            </div>
            <h3 className="font-rajdhani text-[22px] font-bold mb-[16px] tracking-[0.3px]" data-id="element-213">
              Diagnóstico & Motor
            </h3>
            <ul className="list-none flex flex-col gap-[10px]" data-id="element-214">
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-215">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-216"></i>{' '}
                Diagnóstico electrónico
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-217">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-218"></i>{' '}
                Reparación de motor
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-219">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-220"></i>{' '}
                Distribuciones
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-221">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-222"></i>{' '}
                Servicio de aceite
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-223">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-224"></i>{' '}
                Radiadores & Aire acondicionado
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* POTENCIACIÓN & TUNING */}
        <FadeIn delay={0.1} data-id="element-225">
          <div className="bg-gris-medio border border-white/5 rounded-[16px] p-[36px_32px] transition-all duration-300 relative overflow-hidden group hover:-translate-y-[6px] hover:border-azul-neon/40 hover:shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)] hover:bg-[#1e2130]" data-id="element-226">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-azul to-acento opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-227"></div>
            <div className="w-[56px] h-[56px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[14px] flex items-center justify-center mb-[22px]" data-id="element-228">
              <i className="fas fa-tachometer-alt text-[24px] text-acento" data-id="element-229"></i>
            </div>
            <h3 className="font-rajdhani text-[22px] font-bold mb-[16px] tracking-[0.3px]" data-id="element-230">
              Potenciación & Tuning
            </h3>
            <ul className="list-none flex flex-col gap-[10px]" data-id="element-231">
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-232">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-233"></i>{' '}
                Potenciación de motor
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-234">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-235"></i>{' '}
                Tuning profesional
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-236">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-237"></i>{' '}
                ECU Stage 1 / 2 / 3
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-238">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-239"></i>{' '}
                Mapeo y reprogramación
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* CAJAS AUTOMÁTICAS - FEATURED */}
        <FadeIn delay={0.15} className="lg:col-span-2" data-id="element-240">
          <div className="bg-gradient-to-br from-azul/15 to-azul-oscuro/20 border border-azul-neon/50 rounded-[16px] p-[36px_32px] transition-all duration-300 relative overflow-hidden group hover:-translate-y-[6px] hover:shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)]" data-id="element-241">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-azul to-acento opacity-100" data-id="element-242"></div>
            <span className="absolute top-[16px] right-[16px] bg-azul text-white text-[11px] font-semibold px-[12px] py-[4px] rounded-full tracking-[0.5px]" data-id="element-243">
              Especialidad
            </span>
            <div className="w-[56px] h-[56px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[14px] flex items-center justify-center mb-[22px]" data-id="element-244">
              <i className="fas fa-cog text-[24px] text-acento" data-id="element-245"></i>
            </div>
            <h3 className="font-rajdhani text-[22px] font-bold mb-[16px] tracking-[0.3px]" data-id="element-246">
              Cajas Automáticas & Diferenciales
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px] mt-[16px]" data-id="element-247">
              <div className="flex items-center gap-[10px] text-texto-gris text-[14px]" data-id="element-248">
                <i className="fas fa-check text-acento text-[11px]" data-id="element-249"></i>{' '}
                Servicio de cajas automáticas
              </div>
              <div className="flex items-center gap-[10px] text-texto-gris text-[14px]" data-id="element-250">
                <i className="fas fa-check text-acento text-[11px]" data-id="element-251"></i>{' '}
                Diagnóstico de cajas
              </div>
              <div className="flex items-center gap-[10px] text-texto-gris text-[14px]" data-id="element-252">
                <i className="fas fa-check text-acento text-[11px]" data-id="element-253"></i>{' '}
                Servicio de diferenciales
              </div>
              <div className="flex items-center gap-[10px] text-texto-gris text-[14px]" data-id="element-254">
                <i className="fas fa-check text-acento text-[11px]" data-id="element-255"></i>{' '}
                Reparación de diferenciales
              </div>
            </div>
          </div>
        </FadeIn>

        {/* FRENOS & SUSPENSIÓN */}
        <FadeIn delay={0.2} data-id="element-256">
          <div className="bg-gris-medio border border-white/5 rounded-[16px] p-[36px_32px] transition-all duration-300 relative overflow-hidden group hover:-translate-y-[6px] hover:border-azul-neon/40 hover:shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)] hover:bg-[#1e2130]" data-id="element-257">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-azul to-acento opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-258"></div>
            <div className="w-[56px] h-[56px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[14px] flex items-center justify-center mb-[22px]" data-id="element-259">
              <i className="fas fa-circle-notch text-[24px] text-acento" data-id="element-260"></i>
            </div>
            <h3 className="font-rajdhani text-[22px] font-bold mb-[16px] tracking-[0.3px]" data-id="element-261">
              Frenos & Suspensión
            </h3>
            <ul className="list-none flex flex-col gap-[10px]" data-id="element-262">
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-263">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-264"></i>{' '}
                Sistema de frenos completo
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-265">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-266"></i>{' '}
                Amortiguadores
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-267">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-268"></i>{' '}
                Suspensión delantera/trasera
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-269">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-270"></i>{' '}
                Alineación y balanceo
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* ELECTRÓNICA AVANZADA */}
        <FadeIn delay={0.25} data-id="element-271">
          <div className="bg-gris-medio border border-white/5 rounded-[16px] p-[36px_32px] transition-all duration-300 relative overflow-hidden group hover:-translate-y-[6px] hover:border-azul-neon/40 hover:shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)] hover:bg-[#1e2130]" data-id="element-272">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-azul to-acento opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-273"></div>
            <div className="w-[56px] h-[56px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[14px] flex items-center justify-center mb-[22px]" data-id="element-274">
              <i className="fas fa-bolt text-[24px] text-acento" data-id="element-275"></i>
            </div>
            <h3 className="font-rajdhani text-[22px] font-bold mb-[16px] tracking-[0.3px]" data-id="element-276">
              Electrónica Avanzada
            </h3>
            <ul className="list-none flex flex-col gap-[10px]" data-id="element-277">
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-278">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-279"></i>{' '}
                Reparación módulo Airbag
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-280">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-281"></i>{' '}
                Módulo ABS
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-282">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-283"></i>{' '}
                ECU Motor
              </li>
              <li className="flex items-center gap-[10px] text-texto-gris text-[14px] leading-[1.4]" data-id="element-284">
                <i className="fas fa-chevron-right text-acento text-[11px] shrink-0" data-id="element-285"></i>{' '}
                Módulos BCI
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}